import { render, staticRenderFns } from "./bjazxx.vue?vue&type=template&id=32a83117&scoped=true&"
import script from "./bjazxx.vue?vue&type=script&lang=js&"
export * from "./bjazxx.vue?vue&type=script&lang=js&"
import style0 from "./bjazxx.vue?vue&type=style&index=0&id=32a83117&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a83117",
  null
  
)

export default component.exports